/* eslint css-modules/no-unused-class: [2, { markAsUsed: ['boxErrorMsg', 'blockMsg', 'blockInfoMsg', 'blockErrorMsg'] }] */
import React from 'react';

import { ZawSubsidyReissueEligibility } from 'constants/zaw';
import { AriaLiveTee } from 'components/common/AriaLive';

import css from 'styles/containers/returns/zawWarningBanner.scss';

export const ZawWarningBanner = ({ zawSubsidyReissueEligibility }) => {
  if (ZawSubsidyReissueEligibility.SUBSIDY_EXPIRED_NOT_REISSUED !== zawSubsidyReissueEligibility) {
    return null;
  }

  return (
    <div className={css.boxErrorMsg}>
      <AriaLiveTee>
        This return is outside the 30 day Subsidy reissuance period and your Zappos at Work Subsidy will NOT be re-issued to your account. If you
        need a replacement, please contact your supervisor and/or HR*.
      </AriaLiveTee>
    </div>
  );
};

export default ZawWarningBanner;
